export function findSubFormProvider(props, type) {
    if (Array.isArray(props.rootParams.subFormProviders)) {
        return props.rootParams.subFormProviders.find((p) => p.type === type && typeof p.getSubForm === 'function');
    }
    else {
        return undefined;
    }
}
